import { render, staticRenderFns } from "./HighPostPickerConfig.vue?vue&type=template&id=b8a48648&scoped=true"
import script from "./HighPostPickerConfig.vue?vue&type=script&lang=js"
export * from "./HighPostPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a48648",
  null
  
)

export default component.exports